import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import React, { FC } from 'react'
import { Modal } from 'react-bootstrap'

import './ModalShowStudentCertifications.scss'
import { CertificateQueueStatus, CERTIFICATE_QUEUE_STATUS_NAME, ICourseSchedulingEnrollmentListItem } from 'app_types/admin/courseScheduling/courseSchedulingEnrollmentTypes';
import DataTableComponent from 'app_components/commons/dataTable';
import AlertComponent from 'app_components/commons/alert';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { CertificateSettingType, CERTIFICATE_SETTINGS_TYPE_NAME } from 'app_types/admin/certificateSettings/certificateSettings.types';

interface IModalShowStudentCertificationsProps {
  enrollment: ICourseSchedulingEnrollmentListItem
  onClose: (saved?: boolean) => void
  open: boolean
}

const ModalShowStudentCertifications: FC<IModalShowStudentCertificationsProps> = ({
  enrollment,
  onClose,
  open,
}) => {
  const handleCloseModal = () => {
    onClose()
  }

  const getDataTableData = () => {
    if (enrollment?.certificates?.length) {
      return enrollment?.certificates?.map((certificate) => ({
        ...certificate,
        certificateName: !!certificate?.certificateSetting ? certificate?.certificateSetting?.certificateName : certificate?.message,
        certificateType: !!certificate?.certificateSetting
          ? CERTIFICATE_SETTINGS_TYPE_NAME[certificate?.certificateSetting?.certificationType as CertificateSettingType]
          : certificate?.certificateType === 'Academic' ? 'Académico' : 'Auditor',
        state: CERTIFICATE_QUEUE_STATUS_NAME[certificate?.status as CertificateQueueStatus]
      }))
    }
    return []
  }

  return (
    <Modal
      show={open}
      onHide={handleCloseModal}
      size='lg'
    >
      <Modal.Header>
        <Modal.Title>
          Certificados
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-show-student-certifications--layout">
          <TextComponent fontSize="1.25rem" color="black">
            {enrollment?.firstname} {enrollment?.lastname}
          </TextComponent>
          <TextComponent color="black">
            <strong>ID del servicio: </strong> {enrollment?.course_scheduling_doc?.metadata?.service_id}
          </TextComponent>
          {enrollment?.certificates?.length ? (
            <DataTableComponent
              data={getDataTableData()}
              keys={['certificateName', 'certificateType', 'state']}
              headerKeys={['Nombre del certificado', 'Tipo de certificado', 'Estado']}
              tooltipKeys={['certificateName']}
            />
          ) : (
            <AlertComponent description='No hay certificados disponibles' />
          )}
          <div className="modal-show-student-certifications--actions">
            <ButtonComponent onClick={handleCloseModal}>
              Cerrar
            </ButtonComponent>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ModalShowStudentCertifications
